import React, { useState } from "react";
import {
  Dialog,
  useTheme,
  Stack,
  DialogContent,
  TextField,
  Grid,
  Typography,
  } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { tokens } from "../../theme";
import { useEffect } from "react";
import { selectedItems } from "../../config/AppConfig";
import { useAtom } from "jotai";

function TransactionDetailsInfoDialog({
  open,
  onClose,
  onDialogButtonClick,
  onDialogRemoveButtonClick,
  data,
}) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);
  const [errors, setErrors] = useState({});

  const [dialogOpen, setDialogOpen] = useState(open);


//   "result": {
//     "holdBy": "Sung Pik Yeng(Kellie)",
//     "dateOfHold": "24/07/2024",
//     "holdReason": "hold",
//     "referenceNo": "0000000115",
//     "attachmentId": "",
//     "fileName": "",
//     "fileType": ""
// }

// {
//   "batchNo": 58,
//   "version": 19,
//   "type": "Device Reimbursement",
//   "transactionType": "MNP - Prepaid Sim Reimbursement",
//   "companyCode": "A3506",
//   "id": 111827,
//   "yesId": "01173862204@yes.my",
//   "transactionNo": "YSHP099Pb1097587",
//   "transactionDate": "04/07/2023",
//   "planName": "Yes 4G LTE Prepaid Plan",
//   "transactionAmount": 0,
//   "incentiveAmount": 1.9,
//   "companyName": "RU Mega Enterprise"
// }
  useEffect(() => {

    //DebugLog("setSelectedItem >>>"+JSON.parse(selectedItem))
    //DebugLog("data >>>"+JSON.parse(data))
    if (data) {
        const value = {
            dealer: selectedItem.companyName?selectedItem.companyName:"",
            type: selectedItem.type?selectedItem.type:"",
            name: selectedItem.planName?selectedItem.planName:"",
            trxNo: selectedItem.transactionNo?selectedItem.transactionNo:"",
            amount:selectedItem.transactionAmount?selectedItem.transactionAmount:"0.00",
            incentive:selectedItem.incentiveAmount?selectedItem.incentiveAmount:"0.00",
            reason:data.holdReason?data.holdReason:"-",
            attachment:data.attachmentId?data.attachmentId:"-",
          };
      setFormData(value);
    }

   
    setDialogOpen(open);
  }, [open, data]);

  const [formData, setFormData] = useState({
     dealer: "",
    type: "",
    name: "",
    trxNo: "",
    amount:"",
    incentive:"",
    reason:"",
    attachment:"",

  });
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  
  const handleCancel = (e) => {
    e.preventDefault();
   
    onDialogRemoveButtonClick(selectedItem, formData);
  };

  return (
    <Dialog open={open} onClose={onClose}   maxWidth="lg" >
      <DialogContent sx={{ width: '800px' }} >
        
        <Grid container direction={"column"}  xs={12} sx={{ width: '100%', maxWidth: '1000px' }}>
          <Grid container  >
            <Grid container justifyContent="center" alignItems="center" item>
              <Typography fontWeight={"600"} variant="h3" p={1}>
                On Hold
              </Typography>
            </Grid>
           
          </Grid>

          <form>
            <Grid container direction={"column"}  xs={12} sx={{ width: '100%', maxWidth: '1000px' }}>
              
              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Dealer
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Dealer"
                    type="text"
                    name="dealer"
                    fullWidth
                    disabled
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    value={formData.dealer}
                    onChange={handleInputChange}
                    error={Boolean(errors.dealer)}
                    helperText={errors.dealer}
                  />
                </Grid>
              </Grid>

              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                    Type
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Type"
                    type="text"
                    name="type"
                    disabled
                    fullWidth
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    value={formData.type}
                    onChange={handleInputChange}
                    error={Boolean(errors.type)}
                    helperText={errors.type}
                  />
                </Grid>
              </Grid>

              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                   
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Name
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Name"
                    type="text"
                    name="name"
                    disabled
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    fullWidth
                    value={formData.name}
                    onChange={handleInputChange}
                    error={Boolean(errors.name)}
                    helperText={errors.name}
                  />
                </Grid>
              </Grid>


              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   TRX No.
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="TRX No."
                    type="text"
                    name="trxNo"
                    disabled
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    fullWidth
                    value={formData.trxNo}
                    onChange={handleInputChange}
                    error={Boolean(errors.trxNo)}
                    helperText={errors.trxNo}
                  />
                </Grid>
              </Grid>


              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Amount
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Amount"
                    type="text"
                    name="amoount"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    disabled
                    fullWidth
                    value={formData.amount}
                    onChange={handleInputChange}
                    error={Boolean(errors.amount)}
                    helperText={errors.amount}
                  />
                </Grid>
              </Grid>


              <Grid container xs={12} alignItems={"center"} spacing={3}  pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                  Incentive
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Incentive"
                    type="text"
                    name="incentive"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    disabled
                    fullWidth
                    value={formData.incentive}
                    onChange={handleInputChange}
                    error={Boolean(errors.incentive)}
                    helperText={errors.incentive}
                  />
                </Grid>
              </Grid>


              <Grid container xs={12} alignItems={"center"} spacing={3} pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Reason
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Reason"
                    type="text"
                    disabled
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    name="reason"
                    fullWidth
                    value={formData.reason}
                    onChange={handleInputChange}
                    error={Boolean(errors.reason)}
                    helperText={errors.reason}
                  />
                </Grid>
              </Grid>

              <Grid container xs={12} alignItems={"center"} spacing={3} pb={.5}>
                <Grid item xs={4}>
                  <Typography
                    color={colors.grey[100]}
                    fontWeight={"500"}
                     variant="h7"
                    sx={{ textAlign: "right" }}
                  >
                   Attachment
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                   inputProps={{ style: { height: "20px" } }}
                    margin="dense"
                    label="Attachment"
                    type="text"
                    sx={{
                      '& .MuiInputBase-input.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled text
                      },
                      '& .MuiInputLabel-root.Mui-disabled': {
                        color: 'black !important',  // Force red color on disabled label
                      },
                    }}
                    disabled
                    name="attachment"
                    fullWidth
                    value={formData.attachment}
                    onChange={handleInputChange}
                    error={Boolean(errors.attachment)}
                    helperText={errors.attachment}
                  />
                </Grid>
              </Grid>

              <Stack
                direction="row"
                pt={2}
                spacing={2}
                justifyContent={"center"}
              >
                <CustomButton
                  btnBG={colors.primary[900]}
                  btnColor={colors.grey[100]}
                  width={300}
                  btnTxt={"CLOSE"}
                  btnBorder={"1px solid" + colors.primary[800]}
                  onClick={handleCancel}
                ></CustomButton>

               
              </Stack>

            
            </Grid>

            
            {/* Add more fields as needed */}
          </form>
        </Grid>
      </DialogContent>
      
    </Dialog>
  );
}

export default TransactionDetailsInfoDialog;
